<template>
  <div style="margin:20px">
    <FiPageRail title="Planned - Booking Dispatch Board" />

    <div style="font-size: 22px; font-weight: bold; margin-top: 20px; position: relative" class="align-right d-flex align-items-center justify-content-center">
      <a href="#" class="arrows" v-on:click.prevent="shift_detail_graph_date(-1)"><</a>
      &nbsp;&nbsp;<date-picker style="font-size: 20px; font-weight: bold; width:140px" v-model="details_fromDate" :config="options" :placeholder="details_fromDate"></date-picker>&nbsp;&nbsp;
      <a href="#" class="arrows" v-on:click.prevent="shift_detail_graph_date(1)">></a>
    </div>

    <div v-if="!loading">
      <div class="row" style="margin:30px; font-weight: bold; font-size: 24px;">
        <div class="col" style="padding:5px; border: 1px solid grey;">{{items.length}} results</div>
        <div class="col" style="padding:5px"><b-button v-on:click.prevent="load_data()">Reload</b-button></div>
        <div style="margin: 5px"><b-button size="md" variant="success" @click="download">Download</b-button></div>
        <div style="margin: 5px" @click="printPage()"><img height="30px" src="/print-icon.png"/></div>
      </div>
    </div>

    <vue-html2pdf
        :enable-download="true"
        :manual-pagination="true"
        :filename="'daily-dispatch-board-' + details_fromDate"
        pdf-format="letter"
        margin="0px"
        pdf-orientation="landscape"
        pdf-content-width="1050px"
        ref="html2Pdf"
    >
      <section slot="pdf-content">
        <html>
          <template v-for="page in Array(Math.ceil(items.length / 25)).keys()">
          <br/>
            <table border="1" v-if="summary">
              <tr style="font-size: 10px">
                <th>Booking</th>
                <th>Organization</th>
                <th>Group Name</th>
                <th>Trip Ref</th>
                <th>Pickup Location</th>
                <th>Destination</th>
                <th>Driver</th>
                <th>Vehicle</th>
                <th>Veh Type</th>
                <th width="70px">Driver Start</th>
                <th width="70px">Spot Time</th>
                <th width="70px">Departure</th>
                <th width="70px">Arrival</th>
                <th width="70px">Driver End</th>
              </tr>
              <template v-if="idx >= (page * 25) && idx < ((page+1)*25)" v-for="(item,idx) in items">
                <tr>
                  <td style="font-size: 12px">{{item.booking_id}}</td>
                  <td style="font-size: 10px">{{item.organization | trim(28)}}</td>
                  <td style="font-size: 10px">{{item.group_name | trim(28)}}</td>
                  <td style="font-size: 10px;">{{item.trip_reference | trim(28)}}</td>
                  <td style="font-size: 10px">{{item.first_pickup_location | trim(28)}}</td>
                  <td style="font-size: 10px">{{item.destination_location | trim(28)}}</td>
                  <td style="font-size: 10px">{{item.driver}}</td>
                  <td style="font-size: 12px">{{item.vehicle}}</td>
                  <td style="font-size: 10px">{{item.vehicle_type}}</td>
                  <td style="font-size: 12px">{{item.driver_start}}</td>
                  <td style="font-size: 12px">{{item.spot_time}}</td>
                  <td style="font-size: 12px">{{item.departure_time}}</td>
                  <td style="font-size: 12px">{{item.arrival_time}}</td>
                  <td style="font-size: 12px">{{item.driver_end}}</td>
                </tr>
              </template>
            </table>
            <br/>
            <table width="1000px">
              <tr>
                <td>Page {{page+1}} of {{Math.ceil(items.length/25)}}</td>
                <td align="right">{{current_date}}</td>
              </tr>
            </table>

            <div v-if="page+1 != Math.ceil(items.length/25)" class="html2pdf__page-break"/>

          </template>
        </html>
      </section>
    </vue-html2pdf>

    <div v-if="summary">
      <b-table :busy="loading" sticky-header="70vh" bordered :items="items" :fields="visibleFields"
               :current-page="currentPage" :per-page="perPage">

        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner style="width: 3rem; height: 3rem;" label="Loading..."></b-spinner>
          </div>
        </template>

        <template slot="trip_reference" slot-scope="row">
          {{row.item.trip_reference | trim(50)}}
        </template>
        <template slot="first_pickup_location" slot-scope="row">
          {{row.item.first_pickup_location | trim(50)}}
        </template>
        <template slot="destination_location" slot-scope="row">
          {{row.item.destination_location | trim(50)}}
        </template>

      </b-table>
      <b-row v-if="items.length > 10">
        <b-col>
          <b-pagination
              v-model="currentPage"
              :total-rows="items.length"
              :per-page="perPage"
              align="center"
          >
          </b-pagination>
        </b-col>
      </b-row>
    </div>
    <div v-else>
      <div class="text-center text-danger my-2">
        <b-spinner style="width: 3rem; height: 3rem;" label="Loading..."></b-spinner>
      </div>
    </div>
  </div>
</template>

<script>

import {get_dispatch_board, tbn_api_url} from "../networking/tbn_apis";
import {mapState} from "vuex";
import moment from 'moment';
import datetime from 'vuejs-datetimepicker';
import {justDate} from "../helpers/dates";
import axios from "axios";
import VueHtml2pdf from 'vue-html2pdf'

export default {
  name: 'dispatch_board_tbn',
  components: {
     datetime, VueHtml2pdf
  },
  metaInfo: {
    title: "Fleet Integrations",
    titleTemplate: "Fleet Integrations",
  },
  data() {
    return {
      search_filter: '',
      tenant_id: null,
      updating: false,
      reloading: false,
      current_date: moment().format('MMMM Do YYYY, h:mm:ss a'),
      details_fromDate: justDate(moment()),
      items: [],
      summary: null,
      loading: true,
      totalRows: 1,
      currentPage: 1,
      perPage: 300,
      pages: [],
      alert: {
        show: false,
        message: '',
        variant: ''
      },
      options: {
        format: 'MM-DD-YYYY',
        useCurrent: true,
        minDate: moment().subtract(30, 'days'),
        maxDate: moment().add(30, 'days'),
        keepOpen: false,
        showClear: true,
        showClose: true,
        toolbarPlacement: 'top',
      },
      fields: [
        { key: 'booking_id', sortable: true, visible: true, thStyle: { width: "180px" }},
        { key: 'organization', sortable: true, visible: true, thStyle: { width: "180px" }},
        { key: 'group_name', sortable: true, visible: true, thStyle: { width: "150px" }},
        { key: 'trip_reference', sortable: true, visible: true, thStyle: { width: "200px" }},
        { key: 'first_pickup_location', sortable: true, visible: true, thStyle: { width: "200px" }},
        { key: 'destination_location', sortable: true, visible: true, thStyle: { width: "200px" }},
        { key: 'driver', sortable: true, visible: true, thStyle: { width: "200px" }},
        { key: 'vehicle', sortable: true, visible: true, thStyle: { width: "200px" }},
        { key: 'vehicle_type', sortable: true, visible: true,  thStyle: { width: "100px" }},
        { key: 'driver_start', sortable: true, visible: true, thStyle: { width: "200px" }},
        { key: 'spot_time', sortable: true, visible: true, thStyle: { width: "200px" }},
        { key: 'departure_time', label: 'First Departure', sortable: true, visible: true},
        { key: 'arrival_time', label: 'Last Arrival', sortable: true, visible: true},
        { key: 'driver_end', sortable: true, visible: true, thStyle: { width: "200px" }}
      ],
    }
  },
  async created() {
    this.tenant_id = this.user.tenant
    this.fields_all = this.fields
    await this.check_features()
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    printPage() {
      this.$refs.html2Pdf.generatePdf()
    },
    async shift_detail_graph_date(shift) {
      this.details_fromDate = moment(this.details_fromDate, 'MM-DD-YYYY').add(shift, 'days').format('MM-DD-YYYY');
    },
    showAlert(msg, variant, autoclose) {
      this.alert.show = true
      this.alert.message = msg
      this.alert.variant = variant
      autoclose
          ? setTimeout(() => this.closeAlert(), autoclose)
          : null
    },
    closeAlert() {
      this.alert.show = false
      this.alert.message = ''
      this.alert.variant = ''
    },
    async check_features() {
      this.fields = this.fields_all
      this.load_data()
    },
    // get_row_color(item) {
    //   if (item.row_id % 2 == 0) {
    //     console.log("rc: " + item.row_id);
    //     return "rowgray";
    //   }
    // },
    async load_data() {
      this.loading = true
      try {
        var results = await get_dispatch_board(this.tenant_id, moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'))
        const {value: { data = [] } } = results

        this.summary = data.summary
        moment.tz.setDefault(this.summary.timezone)
        this.items = data.results

      } catch(e) {
        this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
      }

      this.loading = false
    },
    async download(){
      this.$emit('showAlert', 'processing download request', 'info', 5000)
      axios.defaults.headers.common.Accept = {}
      axios.post(
          `${tbn_api_url}tbn/dispatch_board/download`,
          {
            tenant: this.tenant_id,
            date: moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'),
          }, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('jwt')}`,
              Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            },
            responseType: 'blob'
          }
      ).then((response) => {
        axios.defaults.headers.common.Accept = 'application/json'
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute(
            'download',
            `dispatch-board-${this.user.tenant}-${this.details_fromDate}.csv`
        )
        document.body.appendChild(link)
        link.click()
        this.$emit('showAlert', 'download complete', 'success', 5000)
      }).catch(e => {
        axios.defaults.headers.common.Accept = 'application/json'
        this.$emit('showAlert', 'data could not be downloaded.', 'danger')
      })
    },
  },
  computed:{
    ...mapState({
      user: state => state.profile.user
    }),
    visibleFields() {
      var custom_fields = null;

      if (this.summary && this.summary.visible_fields)
        custom_fields = this.summary.visible_fields;

      if (custom_fields != null) {
        let new_fields = []
        for (let visible_field of custom_fields.split(",").map(f => f.trim())) {
          let found_field = this.fields_all.filter(field => visible_field == field.key)
          if (found_field.length > 0) {
            new_fields.push(found_field[0]);
          }
        }
        return new_fields;
      } else
        return this.fields.filter(field => field.visible)
    },

  },
  watch: {
    user: {
      deep: true,
      handler() {
        this.check_features()
      }
    },
    details_fromDate() {
      this.load_data();
    }
  }
}
</script>

<style scoped>

.rowgray { background-color: #f2f2f2}


</style>

